import axios from "axios";

import { User } from "../../types/user/user";

export const resetAccount = async (accountId: string): Promise<User> => {
  const { data } = await axios.get(`/accounts/${accountId}/reset`);
  return data;
};
